import { render } from "./Badge.vue?vue&type=template&id=d91dadfe&scoped=true"
import script from "./Badge.vue?vue&type=script&lang=js"
export * from "./Badge.vue?vue&type=script&lang=js"

import "./Badge.vue?vue&type=style&index=0&id=d91dadfe&scoped=true&lang=css"

import exportComponent from "/home/runner/work/channel-xyz/channel-xyz/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d91dadfe"]])

export default __exports__